<template>
  <label class="file-uploader">
    <font-awesome-icon :icon="icons.fileUpload" />
    Buscar archivos
    <input
      type="file"
      class="input"
      @input="$emit('input', $event.target.files[0])"
    />
  </label>
</template>

<script>
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";

export default {
  name: "FileUploader",

  props: {
    value: File
  },

  data: () => ({
    icons: {
      fileUpload: faFileUpload
    }
  })
};
</script>

<style scoped>
.file-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--lengthSm1);
  padding: 0.75rem var(--lengthMd1);
  color: var(--fontColor2);
  font-weight: var(--semi-bold);
  border: 1px dashed var(--grayColor3);
  border-radius: 4px;
  cursor: pointer;
  transition: color 150ms, background-color 150ms;
}

.file-uploader:hover {
  color: var(--fontColor1);
  background-color: var(--grayColor1);
}

.input {
  display: none;
}
</style>
